<template>
    <div class="main_wrap">
        <div class="blockBox blockBox_form top_border_blue bc_white shadow mt_20">
            <!-- 表单部分 -->
            <el-form class="formBox" label-position="right" label-width="1.1rem" label-suffix="：" :model="form">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="所在城市">
                            <SubSelect
                                :selection="cityData"
                                labelKey="CName"
                                valueKey="CName"
                                paramKey="sCity"
                                @selectOption="selectOption">
                            </SubSelect>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="招标行业">
                            <SubSelect
                                :selection="industryData"
                                labelKey="IndustryName"
                                valueKey="IndustryId"
                                paramKey="iIndustryID"
                                @selectOption="selectOption">
                            </SubSelect>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="截止日期">
                            <div class="flex_align">
                                <ul class="selectList mr_15">
                                    <li
                                        class="item"
                                        :class="{'active':!form.sStartTime&&!form.sEndTime}"
                                        @click="setData([])">
                                        不限
                                    </li>
                                </ul>
                                <!-- <el-date-picker
                                    class="diytime_single"
                                    v-model="form.sEndTime"
                                    type="date"
                                    :clearable="false"
                                    value-format="yyyy-MM-dd"
                                    placeholder="自定义时间"
                                    @change="setData">
                                </el-date-picker> -->
                                <div class="diytime">
                                    <el-date-picker
                                        :clearable="false"
                                        v-model="ditTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        value-format="yyyy-MM-dd"
                                        @change="setData">
                                    </el-date-picker>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                
            </el-form>

            <!-- 表单展示（charts） -->
            <div class="formShow_chart">
                <div class="showDetail">
                    <ul class="innerBox">
                        <li class="item" v-for="(item,index) in chartListData.aSumAndCount" :key="index">
                            <p class="value">{{item.value}}</p>
                            <p class="label">{{item.label}}</p>
                        </li>
                    </ul>
                </div>
                <div class="showChart flex_wrap">
                    <div class="w_100 h_100">
                        <Echarts :options="getOptions('base',lineBarChartsData)"></Echarts>
                    </div>
                </div>
            </div>
        </div>
        <div class="formShow_table">
            <div class="blockHead flex_justify_between mt_20">
                <p class="blockTitle">
                    <span class="name">招标采购</span>
                    <span class="split">|</span>
                    <span class="value">共{{total}}条数据</span>
                </p>
                <div class="searchBox">
                    <Search size="big" placeholder="请输入招标名称、开发商、招标行业关键字搜索" @handleIconClick="search"></Search>
                </div>
            </div>
            <div class="blockBox bc_white shadow">
                <TableList :tableObj="tableObj" :type="3" :module="4"></TableList>
            </div>
            <!-- 分页器 -->
            <Pagination :total="total" :current="currentPage" :pageSize="pageSize" @pageChange="pageChange" ></Pagination>
        </div>
    </div>
</template>
<script>
import Echarts from "@/components/Echarts";
import getCharts from "@/utils/getCharts.js";
import chartSet from "@/config/chartSet";
import staticEnum from "@/utils/staticEnum";
import ajaxService from '@/server/api.js'
export default {
    data(){
        return {
            staticEnum,
            cityData:[],//所在城市选项
            industryData:[],//招标行业选项
            form:{
                sCity:'',//城市
                iIndustryID:'',//行业id
                // sEndTime:'',//截止日期
                sStartTime:'',//截止日期——起始
                sEndTime:'',//截止日期——结束
            },//表单筛选项
            sKeyword:'',//搜索关键字
            currentPage:1,//当前页数
            total:0,//表格列表总条数
            pageSize:0,//表格列表单页条数
            chartListData:{},//图表部分数据
            tableObj:{//表格数据
                tableHead:[
                    {
                        prop:'BidTitle',
                        label:'招标名称',
                        align:'left',
                        width:300
                    },
                    {
                        prop:'CityName',
                        label:'城市',
                        align:'center',
                    },
                    {
                        prop:'IndustryName',
                        label:'招标分类',
                        align:'center',
                    },
                    {
                        prop:'CompanyName',
                        label:'开发商',
                        align:'center',
                    },
                    {
                        prop:'BidEndTime',
                        label:'报名截止时间',
                        align:'center',
                    }
                ],
                tableData: [],
            },

            ditTime:[],//自定义截止时间
        }
    },
    components: {
        Echarts,
    },
    watch: {
        form:{
            handler(newVal, oldVal){
                this.currentPage=1;
                this.initData()
            },
            immediate: true,
            deep: true
        },
    },
    computed: {
        tableParam(){
            let temp = {
                sKeyword:this.sKeyword,//搜索关键字
                page:this.currentPage,//页码
            }
            return {...this.form,...temp}
        },
        lineBarChartsData(){
            let obj = {
                title:(this.form.sCity&&this.form.sCity.length?this.form.sCity[0]:'全国')+'招标采购发布趋势',
                xAxisData:[],
                series:[
                    {
                        type:'bar',
                        name:'',
                        data:[],
                        unit:'条'
                    },
                ],
                legend:{
                    show:false,
                },
                grid:{
                    bottom:'12%'
                }
            }
            if(this.chartListData.aCityData&&this.chartListData.aCityData.length){
                this.chartListData.aCityData.forEach(item=>{
                    obj.xAxisData.push(item.BidEndTime)
                    obj.series[0].data.push(item.iCnt)
                    obj.series[0].name=item.CityName
                })
            }
            return chartSet.listLineBarCharts(obj)
        },
    },
    created() {


        // 跳转到新的页面
        // https://screen.youcaiyun.com/list

        window.location.href="https://screen.youcaiyun.com/list"

        this.initOption()
        this.initData()
        document.title="招标采购 - 优采大数据"
    },
    methods: {
        // 初始化form选项
        initOption(){
            this.getCityData()//所在城市
            this.getIndustryData()//招标行业
        },
        // 初始化数据
        initData(){
            this.getChartData(this.form)//图表数据
            this.getListData(this.tableParam)//表格数据
        },
        // 单选
        selectOption(obj){
            console.log('选择了',obj)
            // if(obj.data.length){
            //     this.form[obj.key]=obj.data[obj.data.length-1]
            // }else{
            //     this.form[obj.key]=''
            // }
            this.form[obj.key]=obj.data
            console.log(this.form)
        },
        // 自定义时间选择
        setData(val){
            // this.form.sEndTime=val
            this.form.sStartTime=val[0]
            this.form.sEndTime=val[1]
            this.ditTime=val
            console.log(val,this.form)
        },
        // 搜索
        search(key){
            console.log('搜索',key)
            this.sKeyword=key
            this.getListData(this.tableParam)
        },
        // page页数改变
        pageChange(page){
            console.log('page页数改变',page)
            this.currentPage=page
            this.getListData(this.tableParam)
        },

        // 获取所在城市数据
        getCityData(){
            ajaxService.getProvinceAndCity().then(res=>{
                console.log('城市',res)
                if(!res.ErrorCode){
                    this.cityData=res.Data
                }
            })
        },
        // 获取招标采购行业数据
        getIndustryData(){
            ajaxService.getInvitePurchaseIndustry().then(res=>{
                console.log('招标采购行业',res)
                if(!res.ErrorCode){
                    this.industryData=res.Data
                    
                }
            })
        },
        // 获取图表栏数据
        getChartData(param){
            ajaxService.getInvitePurchaseSumAndCount(param).then(res=>{
                console.log('图表栏数据',res)
                if(!res.ErrorCode){
                    this.chartListData=res.Data
                }
            })
        },
        // 获取表格列表
        getListData(param){
            ajaxService.getInvitePurchaseList(param).then(res=>{
                console.log('表格列表',res)
                if(!res.ErrorCode){
                    this.tableObj.tableData=res.Data.aList
                    this.total=Number(res.Data.iTotal)
                    this.pageSize=res.Data.iPageSize
                }
            })
        },
        // Echarts
        getOptions(echartType,obj) {
            switch (echartType) {
                case 'base':
                    let baseoption = getCharts.getBaseEchart(obj);
                    return baseoption;
                    break;
                default:
                    break;
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.blockBox{
    .selectList{
        .item{
            padding: 0 .1rem;   
        }
    }
}
</style>
